"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerSetWebHIDFlagMsg = exports.LedgerGetWebHIDFlagMsg = void 0;
const router_1 = require("@keplr-wallet/router");
const constants_1 = require("./constants");
class LedgerGetWebHIDFlagMsg extends router_1.Message {
    static type() {
        return "ledger-get-webhid-flag";
    }
    constructor() {
        super();
    }
    validateBasic() {
        // noop
    }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return LedgerGetWebHIDFlagMsg.type();
    }
}
exports.LedgerGetWebHIDFlagMsg = LedgerGetWebHIDFlagMsg;
class LedgerSetWebHIDFlagMsg extends router_1.Message {
    constructor(flag) {
        super();
        this.flag = flag;
    }
    static type() {
        return "ledger-set-webhid-flag";
    }
    validateBasic() {
        if (this.flag == null) {
            throw new router_1.KeplrError("ledger", 101, "Flag is null");
        }
    }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return LedgerSetWebHIDFlagMsg.type();
    }
}
exports.LedgerSetWebHIDFlagMsg = LedgerSetWebHIDFlagMsg;
//# sourceMappingURL=messages.js.map